import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  wrapper: theme => css`
    display: flex;
    align-items: center;
    cursor: pointer;
    gap: ${theme.spacing.xxs};

    p {
      cursor: pointer;
      font-weight: ${theme.fontWeights.normal};
    }
  `,
})

export { useStyles }
